/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nCurrency.vue?vue&type=template&id=e93c9e34&scoped=true"
import script from "./nCurrency.vue?vue&type=script&lang=js"
export * from "./nCurrency.vue?vue&type=script&lang=js"
import style0 from "./nCurrency.vue?vue&type=style&index=0&id=e93c9e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93c9e34",
  null
  
)

export default component.exports